<template>
<div class="chapter">
<div class="inner_page">
<div class="copyrightPage" id="copyrightPage">
<p class="copyrightPage">First published in 1934 by Jonathan Cape</p>
<p class="copyrightPage2">This edition first published in 2004 by Grub Street Publishing, 4 Rainham Close, London SW11 6SS</p>
<p class="copyrightPage2">Copyright this edition © 2004 Grub Street, London</p>
<p class="copyrightPage2">Reprinted 2005, 2007, 2008, 2009, 2010</p>
<p class="copyrightPage2">Copyright text © V. M. Yeates / Guy Yeates</p>
<p class="copyrightPage2"><span class="bold">British Library Cataloguing in Publication Data</span></p>
<p class="copyrightPage1">Yeates, V. M. (Victor M.), 1897–1934</p>
<p class="copyrightPage3">Winged victory</p>
<p class="copyrightPage3">1. World War, 1914-1918—Aerial operations—Fiction</p>
<p class="copyrightPage3">2. War stories</p>
<p class="copyrightPage3">I. Title</p>
<p class="copyrightPage3">823.9′12[F]</p>
<p class="copyrightPage2"><span class="bold">ISBN 978-1-904010-65-4</span></p>
<p class="copyrightPage1"><span class="bold">eISBN 978-1-908117-99-1</span></p>
<p class="copyrightPage2">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the copyright owner.</p>
<p class="copyrightPage2">Cover design by Hugh Adams, AB3 Design</p>
<p class="copyrightPage2">Printed and bound in Great Britain by</p>
<p class="copyrightPage1">MPG Books Ltd, Bodmin, Cornwall</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// WingedVictory_copyright.vue?7781016d